module.exports = __webpack_public_path__ + "img/relax.adc11317.png";